// src/App.js

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AppRoutes from './routes';
import { trackPageView } from './utils/metaPixel';

const App = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView();
  }, [location]);

  return (
    <>
      <AppRoutes />
    </>
  );
};

export default App;
